module.exports = __webpack_public_path__ + "img/icon_img4.e94dc6e8.png";